export class TokenRefreshRequest {
  constructor(private refreshToken: string) {
  }
}
